import Phaser from 'phaser';

import { BootScene } from '../scenes/boot-scene';
import { WorldScene } from '../scenes/world-scene';
import { computeViewport } from './viewport';

export function createGameConfig(parent: string): Phaser.Types.Core.GameConfig {
  const viewport = computeViewport(window.innerWidth, window.innerHeight);

  return {
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#0b0b12',
    width: viewport.width,
    height: viewport.height,
    // CLAUDE.md rule 6: pixel-perfect. Integer zoom, no filtering, no float coordinates.
    pixelArt: true,
    roundPixels: true,
    antialias: false,
    scale: {
      mode: Phaser.Scale.NONE,
      zoom: viewport.zoom,
    },
    // A long press on the world is a held walk (ADR 0043), not a context menu.
    disableContextMenu: true,
    // Sound is `audio/sound.ts`, plain Web Audio shared with the title
    // screen: Phaser must not open a second context of its own.
    audio: { noAudio: true },
    // Registered here, started by hand from main.ts once a session exists.
    scene: [],
  };
}

/** Register the scenes without starting one; main.ts starts Boot with the session. */
export function registerScenes(game: Phaser.Game): void {
  game.scene.add(BootScene.KEY, BootScene, false);
  game.scene.add(WorldScene.KEY, WorldScene, false);
}

/**
 * Keep the logical resolution in sync with the window while preserving
 * integer zoom. The zoom itself follows the screen (ADR 0043): turning a
 * phone, or a desktop window shrunk very short, may change it.
 */
export function bindViewportResize(game: Phaser.Game): void {
  const fit = (): void => {
    const viewport = computeViewport(window.innerWidth, window.innerHeight);
    if (game.scale.zoom !== viewport.zoom) game.scale.setZoom(viewport.zoom);
    game.scale.resize(viewport.width, viewport.height);
  };
  window.addEventListener('resize', fit);
  // iOS reports the new size a moment after the rotation, not always with a resize.
  window.addEventListener('orientationchange', () => {
    window.setTimeout(fit, 250);
  });
}
